//@flow
import Constants   from   "../constants";
import Dispatcher  from '../dispatcher';
import Heap from '../Utils/heap-interface';
import GoogleTagManager from '../Utils/gtm-interface';
import Events from '../Stores/Heap/events';

export default {
  trackCheckoutStepOne(data:Object) {
    Dispatcher.dispatchAction(Constants.HEAP_TRACK_CHECKOUT_STEP_ONE, data);
  },

  trackCheckoutStepTwo(data:Object) {
    Dispatcher.dispatchAction(Constants.HEAP_TRACK_CHECKOUT_STEP_TWO, data);
  },

  trackCheckoutStepThree(data:Object) {
    Dispatcher.dispatchAction(Constants.HEAP_TRACK_CHECKOUT_STEP_THREE, data);
  },

  trackCartGoToCheckout(data:?Object) {
    Dispatcher.dispatchAction(Constants.HEAP_TRACK_CART_GO_TO_CHECKOUT, data);
  },

  trackCancelSurvey(data:Object) {
    Dispatcher.dispatchAction(Constants.HEAP_TRACK_CANCEL_SURVEY, data);
  },

  trackEmailCapture(data:Object) {
    Dispatcher.dispatchAction(Constants.HEAP_TRACK_EMAIL_CAPTURE, data);
  },

  trackPagePerformance(data:Object) {
    Dispatcher.dispatchAction(Constants.HEAP_TRACK_PAGE_PERFORMANCE, data);
  },

  trackScroll(data:Object) {
    Heap.track(Events.SCROLL_DEPTH, data);
  },

  trackNotification(data:Object) {
    Heap.track(Events.NOTIFICATION_DISPLAYED, data);
  },

  trackModal(data:Object) {
    Heap.track(Events.MODAL_DISPLAYED, data);
  },

  trackPaymentRequestActivate() {
    Heap.track(Events.ACTIVATE_PAYMENT_REQUEST);
  },

  trackPaymentRequestSuccess() {
    Heap.track(Events.PAYMENT_REQUEST_SUCCESS);
  },

  trackSubmitOfficeForm(values:Object) {
    Heap.track(Events.SUBMIT_OFFICE_FORM);
    GoogleTagManager.generalEvent({
      event: 'officeFormSuccess',
      officeForm: values,
    });
  },

  initializeSession(data:Object) {
    const {innerWidth, innerHeight} = data;
    Heap.addUserProperties({
      innerWidth,
      innerHeight,
    });
  },
};
